// single product quantity button
document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector(".hh-product-quantity-btn")) return; // Only run if the class exists

    document.querySelectorAll(".hh-product-quantity-btn").forEach(quantityContainer => {
        const input = quantityContainer.querySelector("input");
        const minusButton = quantityContainer.querySelector(".hh-product-btn-minus");
        const plusButton = quantityContainer.querySelectorAll(".hh-product-btn-minus")[1]; // Second button is plus

        minusButton.addEventListener("click", function () {
            let value = parseInt(input.value, 10) || 0;
            let min = parseInt(input.min, 10) || 1;

            if (value > min) {
                input.value = value - 1;
                input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger WooCommerce events
            }
        });

        plusButton.addEventListener("click", function () {
            let value = parseInt(input.value, 10) || 0;
            let max = parseInt(input.max, 10) || 9999;

            if (value < max) {
                input.value = value + 1;
                input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger WooCommerce events
            }
        });
    });
});

// // show address edit form if edit address button is clicked
// document.addEventListener('DOMContentLoaded', function () {
//     // Check if the .hh-account__tab-address exists on the page
//     if (document.querySelector('.hh-account__tab-address')) {
//         // Attach click event listener to all .add-address buttons
//         document.querySelectorAll('.add-address button').forEach(function (button) {
//             button.addEventListener('click', function () {
//                 // Find the closest .woocommerce-Address parent to target the correct column
//                 var column = button.closest('.woocommerce-Address');
                
//                 // Find the .edit-address within the current column
//                 var editAddress = column.querySelector('.edit-address');
                
//                 // If editAddress is found, toggle the .show class
//                 if (editAddress) {
//                     editAddress.classList.add('show');
//                 }
//             });
//         });
//     }
// });

// // show account edit form if edit account button is clicked
document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.woocommerce-edit-account')) return;
  
    const buttons = document.querySelectorAll('.hh-account-information button, .hh-account-password button');
  
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const form = this.closest('.hh-account-information, .hh-account-password')?.querySelector('.woocommerce-EditAccountForm');
        if (form) {
          form.classList.add('show');
        }
      });
    });
});
  
